import resolve from '../../modules/api/resolve';
import { apiPost, generateFormData } from '../../modules/apiHelper';
import { urlFriendly } from '../../modules/dataHelper';

export default {
  async addContentMedia(context, data) {
    const formData = generateFormData(data);
    formData.set('senderid', context.rootState.User.id);
    formData.set('userid', context.rootState.User.id);
    formData.append('file1', data.file1, urlFriendly(data.file1.name));
    formData.set('name', data.file1.name);
    formData.set('companyid', data.companyId);
    formData.set('progid', data.programId);

    return await resolve(apiPost('prog_share_resource_dt', formData, 3))
      .catch((err) => {
        console.warn('ERROR::addContentMedia', err);
        return false;
      })
      .then((res) => {
        return res;
      });
  },

  async fetchContentMedia(context, mediaId) {
    return await resolve(apiPost('prog_share_resource_dt', generateFormData({ resourceid: mediaId }), 80))
      .catch((err) => {
        console.warn('ERROR::fetchContentMedia', err);
        return false;
      })
      .then((res) => {
        if (!res) return false;

        return res.prog_share_resource_dt?.[0] || false;
      });
  },
};
